module.exports = __webpack_public_path__ + "img/partner_img25.de8ccbe3.png";